export default __webpack_public_path__ + "static/media/Journey2.097571bb.jpeg";